const searchTypes = {
  PACKAGE: 'package',
  TITLE: 'title',
};

export default searchTypes;
